import { useContext, useEffect, useRef } from "react";
import { UseFormGetValues } from "react-hook-form";

import { CASE_FORM_PRESCRIPTION_VALUES } from "src/constants/cases";
import { CaseContext } from "src/context/caseContext";

import { AddCaseProps } from "src/pages/addCase/types";
import { PrescriptionObjKeyProps } from "src/types/case";




export function usePageTrackingAndStorage(fetchLatestData: UseFormGetValues<AddCaseProps>, isDirty: boolean, step: number) {
  const { isCaseDraftSaved, draftCaseId } = useContext(CaseContext)
  const refBaseCaseDraftCheck = useRef(isCaseDraftSaved)
  const refDraftCaseId = useRef(draftCaseId)

  const isPrescriptionAttributesUpdated = () => {
    const updatedPrescriptionValues = fetchLatestData("prescription_attributes")
    return Object.keys(updatedPrescriptionValues).some((key: unknown) => {
      if (key === "cp_diuretics" || key === "diagnosis_code")
        return false
      else
        return true
        //return updatedPrescriptionValues[key as PrescriptionObjKeyProps] !== CASE_FORM_PRESCRIPTION_VALUES[key as PrescriptionObjKeyProps]
    });
  }

  // Handle page refresh / close
  useEffect(() => {
    const handleBeforeUnload = () => {
      if ((isPrescriptionAttributesUpdated() || isDirty) && !refBaseCaseDraftCheck.current)
        localStorage.setItem('newCase', JSON.stringify({ newData: fetchLatestData(), step, draftCaseId: refDraftCaseId.current }))
    };

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
      // Save to localStorage on route change
      handleBeforeUnload()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    refBaseCaseDraftCheck.current = isCaseDraftSaved;
  }, [isCaseDraftSaved]);
  
  useEffect(() => {
    refDraftCaseId.current = draftCaseId;
  }, [draftCaseId]);
};
